<main role="main">
  <div [hidden]="!resourcesLoaded">
    <router-outlet></router-outlet>
  </div>
</main>
